import React, { useEffect } from "react";

import { Router, useNavigate, Navigate } from "react-router-dom";

import { Route, Routes } from "react-router-dom";
import { useAuth } from "./context/AuthContext";

import Login from "./components/login/Login";

const UnAuthenticated = () => {
  return (
    <>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
      {/* <AdminRoutes/> */}
      {/* <EndUserRoutes/> */}
      {/* <SupportUserRoutes/> */}
    </>
  );
};
export default UnAuthenticated;
